const frMessages = {
  "chat.end": "Redémarrez votre conversation de chat",
  "chat.endall": "Mettre fin à la discussion",
  "chat.cancel": "Annuler",
  "chat.cookie":
    "Cet assistant numérique utilise des cookies pour vous garantir la meilleure expérience",
  "chat.learn": "Apprendre encore plus",
  "chat.minimize": "Minimiser",
  "chat.hide": "proche",
  "chat.hidebot.text": "Fermer fera disparaître l'avatar pendant 15 minutes",
  "chat.hidebot": "Fermer le robot",
  "chat.restart": "Redémarrer",
  "switch.language": "Changer de langue",
  "switch.property": "Changer de propriété",
  "restart.converstation": "Redémarrer la conversation",
  "chat.endtext": "Voulez-vous vraiment mettre fin au chat en cours ?",
  "check.availabity": "Consultar disponibilidad",
  "check.availabity.submit": "Enviar",
  "check.availabity.cancel": "Annuler",
  "check.availabity.adults": "Adultes ",
  "check.availabity.children": "Enfants",
  "check.availabity.child.age": "Âge - Enfant",
  "feedback.leave": "Laisser les commentaires",
  "feedback.leave.message": "Laissez un message",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Soumettre un cas",
  "caseform.system": "Système",
  "caseform.loading.systems": "Chargement des systèmes...",
  "caseform.select.system": "Sélectionner le système",
  "caseform.error.systems": "Erreur lors du chargement des systèmes",
  "caseform.scenario": "Scénario",
  "caseform.loading.scenarios": "Chargement des scénarios...",
  "caseform.select.scenario": "Sélectionner le scénario",
  "caseform.error.scenarios": "Erreur lors du chargement des scénarios",
  "caseform.topic": "Sujet",
  "caseform.loading.topics": "Chargement des sujets...",
  "caseform.select.topic": "Sélectionner le sujet",
  "caseform.error.topics": "Erreur lors du chargement des sujets",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Sujet",
  "caseform.description": "Description",
  "caseform.attachments": "Pièces jointes",
  "caseform.attachments.remove": "Supprimer",
  "caseform.submit": "Soumettre",
  "caseform.cancel": "Annuler",
  "caseform.success.title": "Cas créé",
  "caseform.success.message": "Votre cas a été créé avec succès.",
  "caseform.success.caseNumber": "Numéro de cas :",
  "caseform.success.transferToLiveAgent":
    "Vous allez être transféré à un agent en direct.",
  "caseform.success.newChatWindowRightSide":
    "Une nouvelle fenêtre de chat s'ouvrira sur le côté droit de votre navigateur.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Choisissez une action",
  "simpleaction.body":
    "Veuillez sélectionner l'une des options suivantes :{br}{b}Créer un cas{/b} pour soumettre une demande de support, ou {b}Démarrer un chat{/b} pour vous connecter avec un agent maintenant.",
  "simpleaction.startchat": "Démarrer un chat",
  "simpleaction.createcase": "Créer un cas",
  "caseform.error.generic": "Erreur lors de la création du cas.",
  "caseform.error.generic.message":
    "Une erreur s'est produite lors de la création de votre cas. Veuillez réessayer plus tard.",
};
export default frMessages;
